import _ from "lodash";
import { wealthProApi } from "../../redux/api";
import { buildSearchParamsString, useCacheKeySerializeQueryArgsHandler, useCacheKeyTransformResponseHandler } from "../../redux/helpers";

const hoAdminHubwiseEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ["HubwiseProcesses"]
}).injectEndpoints({
    endpoints: (builder) => ({
        fetchHubwiseJobs: builder.query({
            query: ({ page, limit, sort, filter = {} }) => ({
                url: buildSearchParamsString('api/headofficeadmin/hubwise/jobs', { page, limit, sort }),
                method: 'POST',
                body: filter
            }),
            transformResponse: useCacheKeyTransformResponseHandler,
            serializeQueryArgs: useCacheKeySerializeQueryArgsHandler,
            merge: (currentCache, newItems, ...rest) => {
                if (_.isEqual(currentCache.cacheKey, newItems.cacheKey) && newItems.pagination.page !== 1) {
                    currentCache.pagination = newItems.pagination;
                    currentCache.results.push(...newItems.results);
                } else {
                    currentCache.newRecordsSinceCache = 0;
                    currentCache.cacheKey = newItems.cacheKey;
                    currentCache.pagination = newItems.pagination;
                    currentCache.results = [...newItems.results];
                }
            },
            providesTags: ["HubwiseProcesses"]
        }),
        uploadHubwiseFiles: builder.mutation({
            query: (body) => ({
                url: 'api/headofficeadmin/hubwise',
                method: 'POST',
                body
            }),
            invalidatesTags: ["HubwiseProcesses"],
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                const insertNullResult = dispatch(wealthProApi.util.updateQueryData("fetchHubwiseJobs", {}, (draft) => {
                    draft.results.unshift(null);
                    draft.pagination.totalCount++;
                }));

                try {
                    await queryFulfilled
                } catch (err) {
                    insertNullResult.undo();
                }
            }
        }),
        patchHubwiseTransactionType: builder.mutation({
            query: ({ platformTransactionId, newType }) => ({
                url: `api/headofficeadmin/hubwise/unmatched/${platformTransactionId}/${newType}`,
                method: 'PATCH'
            }),
            async onQueryStarted({ platformTransactionId, newType }, { dispatch, queryFulfilled }) {
                const patchHubwiseResult = dispatch(wealthProApi.util.updateQueryData("fetchHubwiseTransactionExceptions", {}, (draft) => {
                    const transaction = draft.results.find(t => t.id === platformTransactionId);
                    if (transaction != null)
                        transaction.platformTransactionType = newType;
                }));

                try {
                    const patchTransactionsResult = dispatch(wealthProApi.util.updateQueryData("fetchHeadOfficePlatformTransactionExceptions", {}, (draft) => {
                        const transaction = draft.results.find(t => t.id === platformTransactionId);
                        if (transaction != null)
                            transaction.platformTransactionType = newType;
                    }));

                    try {
                        await queryFulfilled;
                    } catch (serviceError) {
                        console.error(`Error updating HubWise Transactions in Service: ${serviceError}`);

                        patchHubwiseResult.undo();
                        patchTransactionsResult.undo();
                    }
                } catch (localError) {
                    console.error(`Error updating Platform Transactions Cache: ${localError}`);
                    patchHubwiseResult.undo();
                }

            }
        })
    })
})

export const {
    useLazyFetchHubwiseJobsQuery,
    useUploadHubwiseFilesMutation,
    usePatchHubwiseTransactionTypeMutation
} = hoAdminHubwiseEndpoints;